module.exports = __webpack_public_path__ + "img/yx.a396833f.png";